import React, { useContext } from 'react';
import { Grid, Chip, Button, FormLabel } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { map } from 'lodash';
import { number, obj, func, bool, shape } from 'prop-types';

import { FormTextField, MultiSelect, FormSelect } from '../../../../components';
import { APP_APIS_LIST_STATES_FILTER_OPTIONS } from '../../../../constants';
import { getI18n } from '../../../../utils/intl';
import AppAPIListContext from './';

export const FilterByName = (props) => (
  <Grid item md={3} sm={4} xs={6}>
    <FormTextField
      {...props}
      id="app-apis-filter-by-name"
      data-apim-test="app-apis-filter-by-name"
    />
  </Grid>
);

export const FilterBySeparator = (props) => (
  <Grid item md={6} sm={4} xs={6} className={props.fieldContainerClass} />
);

FilterBySeparator.propTypes = {
  fieldContainerClass: shape({}),
};

export const Tags = ({ tags, numSelectedRows }) => {
  const appAPIListContext = useContext(AppAPIListContext);
  const clickable = (numSelectedRows === 0);
  return map(
    tags,
    tag => (
      <Chip
        variant="outlined" size="small"
        clickable={clickable}
        style={{ marginRight: '2px' }}
        key={tag} label={tag}
        onClick={() => {
          if(clickable) { appAPIListContext.onClickTag(tag) }
        }}
      />
    ),
  );
}

export const FilterByState = (props) => (
  <Grid item md={3} className={props.fieldContainerClass}>
    <FormSelect
      {...props}
      id="apis-filter-by-state"
      data-apim-test="apis-filter-by-state"
      data={APP_APIS_LIST_STATES_FILTER_OPTIONS}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

FilterByState.propTypes = {
  fieldContainerClass: shape({}),
};

export const FilterByTags = (props) => (
  <Grid data-apim-test={'apis-filter-by-tags'} className={props.fieldContainerClass} item md={3}>
    <MultiSelect
      {...props}
    />
  </Grid>
);

FilterByTags.propTypes = {
  fieldContainerClass: shape({}),
};

export const HeaderActionButtons = (props) => {
  const {
    classes = {},
    bulkActionsItemsCount,
    onAssign,
    onUnassign,
    disableAdd,
    disableRemove,
  } = props;

  const id = 'app-api-assignment'
  const intl = getI18n(useIntl());

  return (
    <div className={classes.actionsFieldContainer}>
      <FormLabel className={ classes.actionsLabel }>
        {intl.getI18nMessage('label.application.details.api.actions.count', { count: bulkActionsItemsCount })}
      </FormLabel>
      <Grid
        item md={12} sm={12} xs={12}
        className={classes.headerButtons}
      >
        <Button
          variant="contained" color="secondary"
          className={classes.addButton}
          id={`${id}-add`} data-apim-test={`${id}-add`} data-layer7-test={`${id}-add`}
          onClick={onAssign}
          disabled={disableAdd}
        >
          {intl.getI18nMessage('label.application.details.apis.actions.assign')}
        </Button>
        <Button
          variant="contained" color="secondary"
          className={classes.removeButton}
          id={`${id}-remove`} data-apim-test={`${id}-remove`} data-layer7-test={`${id}-remove`}
          onClick={onUnassign}
          disabled={disableRemove}
        >
          {intl.getI18nMessage('label.application.details.apis.actions.unassign')}
        </Button>
      </Grid>
    </div>
  );
}

HeaderActionButtons.propTypes = {
  classes: obj,
  bulkActionsItemsCount: number,
  onAssign: func,
  onUnassign: func,
  disableAdd: bool,
  disableRemove: bool,
};
